var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2052 6.49991H1.7949C0.803359 6.49991 0 5.82853 0 4.99993C0 4.17133 0.803359 3.49991 1.7949 3.49991H26.2052C27.1966 3.49991 28 4.17129 28 4.99993C28 5.82857 27.1966 6.49991 26.2052 6.49991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3818 15.4999H1.39603C0.624835 15.4999 0 14.8285 0 13.9999C0 13.1713 0.624835 12.4999 1.39603 12.4999H20.3818C21.1529 12.4999 21.7778 13.1713 21.7778 13.9999C21.7778 14.8286 21.1529 15.4999 20.3818 15.4999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2052 24.5H1.7949C0.803359 24.5 0 23.8286 0 23C0 22.1714 0.803359 21.5 1.7949 21.5H26.2052C27.1966 21.5 28 22.1714 28 23C28 23.8286 27.1966 24.5 26.2052 24.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.051f397160c0cdaa758c7335d07dfe95.svg";
export { ForwardRef as ReactComponent };